import React from 'react';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router-dom';

import { Button } from '~components';

import FormInputGroupParticipants from '~appointments/components/FormInputGroupParticipants';

interface AttendeeParticipant {
  id?: string | number | null;
  full_name?: string;
  user_id?: number;
  client_id?: number;
  [key: string]: any;
}

interface AttendeesAppointment {
  id?: string | number | null;
  users?: AttendeeParticipant[];
  clients?: AttendeeParticipant[];
}

interface ComponentProps {
  appointment: AttendeesAppointment;
  id: string;
  isRepeat: boolean;
  onSave: (users: AttendeeParticipant[], clients: AttendeeParticipant[]) => void;
}

const GroupAppointmentAttendees: React.FC<ComponentProps> = ({ appointment, id, isRepeat, onSave }) => {
  const navigate = useNavigate();

  const manualAddWorkerRoute = isRepeat
    ? `/appointments/groups/${id}/users/new?repeat=true`
    : `/appointments/groups/${id}/users/new`;

  const manualAddClientRoute = isRepeat
    ? `/appointments/groups/${id}/clients/new?repeat=true`
    : `/appointments/groups/${id}/clients/new`;

  const handleManualAddWorker = () => {
    navigate(manualAddWorkerRoute);
  };

  const handleManualAddClient = () => {
    navigate(manualAddClientRoute);
  };

  const initialValues = {
    users: appointment?.users ?? [],
    clients: appointment?.clients ?? [],
  };

  const handleSubmit = (values: typeof initialValues) => {
    onSave(values.users, values.clients);
  };

  return (
    <div className="p-2 group-appointment-attendees" data-cy="group-appointment-attendees">
      <p className="mb-3 text-muted">
        Quick add copies shell defaults. Manual add opens the appointment form so you can set a different time, service
        type, or package for that individual.
      </p>

      <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <FormInputGroupParticipants values={values as any} setFieldValue={setFieldValue} />
            <div className="mt-3">
              <Button
                type="submit"
                color="success"
                size="sm"
                disabled={isSubmitting}
                dataCy="group-attendees-save-button"
              >
                Save Attendees
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      <div className="d-flex gap-2 mt-3">
        <Button
          color="primary"
          size="sm"
          onClick={handleManualAddWorker}
          dataCy="group-attendees-manual-add-worker-button"
        >
          Manual add worker
        </Button>
        <Button
          color="primary"
          size="sm"
          onClick={handleManualAddClient}
          dataCy="group-attendees-manual-add-client-button"
        >
          Manual add client
        </Button>
      </div>
    </div>
  );
};

export default GroupAppointmentAttendees;
